import { Header } from "components/atoms/Typography";
import TotalCarbonEmissionsAndEnergyCard from "./TotalCarbonEmissionsAndEnergyCard";
import DecarbonizationForecastChart from "./DecarbonizationForecastChart";

interface PerformanceImpactProps {
    measure: CarbonReductionMeasure;
}

function PerformanceImpact({ measure }: PerformanceImpactProps) {
    return (
        <div className="project-report__section">
            <Header size="medium">Performance impact</Header>
            <div className="performance-impact">
                <TotalCarbonEmissionsAndEnergyCard measure={measure} />
                <DecarbonizationForecastChart measure={measure} />
            </div>
        </div>
    );
}

export default PerformanceImpact;
